import { render, staticRenderFns } from "./RednaxDatatableComponent.vue?vue&type=template&id=1c58d080&scoped=true&"
import script from "./RednaxDatatableComponent.vue?vue&type=script&lang=js&"
export * from "./RednaxDatatableComponent.vue?vue&type=script&lang=js&"
import style0 from "./RednaxDatatableComponent.vue?vue&type=style&index=0&id=1c58d080&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c58d080",
  null
  
)

export default component.exports